import { FormVariant } from '../../forms';
import { MissionReportInfoForm } from '../../forms/MissionReportInfo';

import { useInitHandler } from '../MissionReport/hooks/useInitHandler.hook';

export const MissionReportInit = () => {
  const { onInit } = useInitHandler();

  return (
    <MissionReportInfoForm
      formVariant={FormVariant.Creation}
      submitLabel="Initialiser"
      useSubmitFactory={onInit}
    />
  );
};
